export const BLUE = "var(--glow-calendar)";
export const CAT_RGB = { Family: "var(--st-blue)", School: "var(--st-amber)", Athletics: "var(--st-emerald)", Flights: "var(--st-sky)", Vacations: "var(--st-pink)" };
export const CATEGORIES = Object.keys(CAT_RGB);
export const deviceTz = () => Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
export const pad = (n) => String(n).padStart(2, "0");
export const ymd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const parseYmd = (s) => { const [y, m, d] = s.split("-").map(Number); return new Date(y, m - 1, d); };
export const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };

// Day key (device time zone) an occurrence starts on.
export const dayOf = (e) => (e.all_day ? e.start : ymd(new Date(e.start)));

// Days an occurrence covers, as device-local YYYY-MM-DD keys.
export function daysOf(e) {
  if (!e.all_day) return [dayOf(e)];
  const out = [];
  for (let d = parseYmd(e.start); ymd(d) <= e.end; d = addDays(d, 1)) out.push(ymd(d));
  return out;
}

const differs = () => !!window.__hubTz && deviceTz() !== window.__hubTz;
const devT = (iso, zone) => new Date(iso).toLocaleTimeString([], { hour: "numeric", minute: "2-digit", ...(zone ? { timeZoneName: "short" } : {}) });
function hubT(iso, zone) {
  const t = new Date(iso).toLocaleTimeString([], { hour: "numeric", minute: "2-digit", timeZone: window.__hubTz });
  if (!zone) return t;
  let z;
  try { z = new Intl.DateTimeFormat("en-US", { timeZone: window.__hubTz, timeZoneName: "shortGeneric" }).formatToParts(new Date(iso)).find((x) => x.type === "timeZoneName")?.value; } catch { z = null; }
  return `${t} ${z || tzShort(window.__hubTz)}`;
}

// Viewer's time; when the viewer's zone differs from the hub's, also the hub time, e.g. "2:00 PM PDT · 5:00 PM ET".
export const fmtTime = (iso) => (differs() ? `${devT(iso, true)} · ${hubT(iso, true)}` : devT(iso));

export const whenLabel = (e) => {
  if (e.all_day) return e.start === e.end ? "All day" : `All day · until ${parseYmd(e.end).toLocaleDateString([], { month: "short", day: "numeric" })}`;
  return differs() ? `${devT(e.start)} – ${devT(e.end, true)} · ${hubT(e.start)} – ${hubT(e.end, true)}` : `${devT(e.start)} – ${devT(e.end)}`;
};

// UTC ISO -> "YYYY-MM-DDTHH:MM" wall time in tz.
export function toLocal(iso, tz) {
  const p = Object.fromEntries(new Intl.DateTimeFormat("en-CA", { timeZone: tz, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23" })
    .formatToParts(new Date(iso)).map((x) => [x.type, x.value]));
  return `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}`;
}

export const tzShort = (tz) => new Intl.DateTimeFormat([], { timeZone: tz, timeZoneName: "short" }).formatToParts(new Date()).find((x) => x.type === "timeZoneName")?.value || tz;

export function matches(e, cats, member) {
  if (cats.length && !cats.includes(e.category)) return false;
  return !member || !e.member_keys.length || e.member_keys.includes(member);
}
